import { useState } from "react";
import { Card, Tooltip, Tag } from "antd";
import { ReloadOutlined, StopOutlined, EditOutlined } from "@ant-design/icons";
import MondayButton from "../../../../commonComponents/MondayButton/MondayButton";
import EditQuoteOfTheDay from "../../../../commonComponents/EditQuoteOfTheDay/EditQuoteOfTheDay";
import { sourceTag } from "../../../../../constantsFactory/quoteOfTheDay";

// Today's line as the header renders it, plus the manual re-pick and the two
// ways of rejecting it.
function CurrentQuoteCard({
  current,
  generating,
  onGenerate,
  onBlockQuote,
  onBlockAuthor,
  onEdited,
  isDarkMode,
}) {
  const [editing, setEditing] = useState(false);
  const hasQuote = !!current?.quote;
  const tag = sourceTag(current?.source);

  return (
    <Card
      className={`citimiCard ${isDarkMode ? "dark" : ""}`}
      title="Citimi i sotëm"
      extra={
        <div className="cardActions">
          {hasQuote && current?.source !== "wish" && (
            <>
              <Tooltip title="Nuk shfaqet më ky citim dhe zgjidhet një tjetër">
                <span>
                  <MondayButton
                    className="mondayButtonRed"
                    Icon={<StopOutlined />}
                    onClick={onBlockQuote}
                  >
                    Blloko citimin
                  </MondayButton>
                </span>
              </Tooltip>
              {!!current?.author && (
                <Tooltip title={`Asnjë citim nga ${current.author}`}>
                  <span>
                    <MondayButton
                      className="mondayButtonRed"
                      Icon={<StopOutlined />}
                      onClick={onBlockAuthor}
                    >
                      Blloko autorin
                    </MondayButton>
                  </span>
                </Tooltip>
              )}
            </>
          )}
          <Tooltip title="Shkruaj vetë citimin e sotëm">
            <span>
              <MondayButton
                className="mondayButtonBlue"
                Icon={<EditOutlined />}
                onClick={() => setEditing(true)}
              >
                Ndrysho
              </MondayButton>
            </span>
          </Tooltip>
          <Tooltip title="Zgjedh një citim të ri për sot">
            <span>
              <MondayButton
                className="mondayButtonGreen"
                spin={generating}
                Icon={<ReloadOutlined />}
                onClick={onGenerate}
              >
                Gjenero tani
              </MondayButton>
            </span>
          </Tooltip>
        </div>
      }
    >
      {hasQuote ? (
        <div className="citimiCurrent">
          <p className="quote">“{current.quote}”</p>
          {/* The published line is a translation; the source stays visible. */}
          {!!current.quoteEn && (
            <p className="original">“{current.quoteEn}”</p>
          )}
          {!!current.author && <p className="author">— {current.author}</p>}
          <div className="meta">
            {!!current.date && <span>{current.date}</span>}
            {!!current.occasion && <Tag color="gold">{current.occasion}</Tag>}
            {current.editedBy ? (
              <Tag color="gold">Vendosur nga {current.editedBy}</Tag>
            ) : (
              <Tag color={tag.color}>{tag.label}</Tag>
            )}
          </div>
        </div>
      ) : (
        <p className="citimiEmpty">
          Nuk ka ende një citim të ruajtur për sot.
        </p>
      )}

      <EditQuoteOfTheDay
        open={editing}
        quote={current}
        onCancel={() => setEditing(false)}
        onSaved={() => {
          setEditing(false);
          onEdited();
        }}
      />
    </Card>
  );
}

export default CurrentQuoteCard;
